module.exports = __webpack_public_path__ + "img/hero-shop.385e732d.png";